import React from 'react';

const CONFIG_MODULOS_FINANZAS = {
    LIBRO_IVA: { 
        label: 'Libro IVA', 
        icon: '🏛️',
        desc: 'Débito, crédito y posición AFIP'
    },
    CONCILIACIONES: { 
        label: 'Conciliaciones', 
        icon: '⚖️',
        desc: 'Auditoría de desfases CBU'
    },
    CASH_FLOW: { 
        label: 'Cash Flow Banco', 
        icon: '💵',
        desc: 'Flujo efectivo de ingresos y egresos'
    },
    RETENCIONES: { 
        label: 'Retenciones', 
        icon: '🛡️',
        desc: 'Comprobantes de retenciones sufridas'
    }
};

const FiltrosSidebarFinanzas = ({
    moduloRaiz,
    setModuloRaiz,
    isDbLoaded,
    opcionesFiltrosUnicas = {},
    multiFiltros,
    setMultiFiltros
}) => {
    return (
        <aside className="w-80 shrink-0 bg-white border-r border-slate-200/80 overflow-y-auto p-5 flex flex-col gap-6 custom-scrollbar text-left h-full shadow-[2px_0_10px_-5px_rgba(0,0,0,0.02)]">
            {/* 1. SELECCIÓN DE MÓDULO (LISTA VERTICAL APILADA) */}
            <div className="space-y-3">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
                    1. Módulo Financiero
                </label>
                <div className="flex flex-col gap-2">
                    {Object.entries(CONFIG_MODULOS_FINANZAS).map(([key, config]) => {
                        const isSelected = moduloRaiz === key;
                        return (
                            <button
                                key={key}
                                type="button"
                                onClick={() => setModuloRaiz(key)}
                                className={`w-full py-3 px-3.5 rounded-xl font-bold transition-all duration-200 flex items-center justify-between border select-none active:scale-[0.98] ${
                                    isSelected
                                        ? 'bg-[#01032d] text-white border-[#01032d] shadow-md shadow-[#01032d]/10'
                                        : 'bg-slate-50/60 text-slate-700 border-slate-200/80 hover:bg-slate-100/70 hover:border-slate-300'
                                }`}
                            >
                                <div className="flex items-center gap-3">
                                    <span className="text-base p-1.5 bg-white/10 rounded-lg">{config.icon}</span>
                                    <div className="flex flex-col text-left">
                                        <span className="text-xs font-black uppercase tracking-wider">{config.label}</span>
                                        <span className={`text-[9px] font-medium leading-none mt-0.5 ${isSelected ? 'text-slate-300' : 'text-slate-400'}`}>
                                            {config.desc}
                                        </span>
                                    </div>
                                </div>
                                {isSelected && (
                                    <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse shrink-0"></span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* 2. FILTROS DE SEGMENTACIÓN (VISIBLES SÓLO CUANDO SE HA CONSULTADO LA BD) */}
            {isDbLoaded && (
                <div className="space-y-4 pt-4 border-t border-slate-100">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
                        2. Segmentación
                    </label>

                    {/* Área / Razón Social */}
                    <div className="space-y-1">
                        <label className="text-[9px] font-black text-slate-400 uppercase">Área / Razón Social</label>
                        <select
                            value={multiFiltros.areaId}
                            onChange={(e) => setMultiFiltros(prev => ({ ...prev, areaId: e.target.value }))}
                            className="w-full border border-slate-200 rounded-xl p-2.5 text-xs font-bold bg-white text-[#01032d] outline-none cursor-pointer hover:border-slate-300 transition-colors"
                        >
                            <option value="TODAS">TODAS LAS ÁREAS</option>
                            {(opcionesFiltrosUnicas.areas || []).map(a => (
                                <option key={a.id} value={a.id}>{a.nombre}</option>
                            ))}
                        </select>
                    </div>

                    {/* Moneda */}
                    <div className="space-y-1">
                        <label className="text-[9px] font-black text-slate-400 uppercase">Moneda</label>
                        <select
                            value={multiFiltros.moneda}
                            onChange={(e) => setMultiFiltros(prev => ({ ...prev, moneda: e.target.value }))}
                            className="w-full border border-slate-200 rounded-xl p-2.5 text-xs font-bold bg-white text-[#01032d] outline-none cursor-pointer hover:border-slate-300 transition-colors"
                        >
                            <option value="TODAS">TODAS LAS MONEDAS</option>
                            <option value="ARS">ARS ($)</option>
                            <option value="USD">USD (U$S)</option>
                        </select>
                    </div>
                </div>
            )}
        </aside>
    );
};

export default FiltrosSidebarFinanzas;